module.exports = __webpack_public_path__ + "static/img/bg_map_normal@2x.9791a42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_map_normal@2x.png
// module id = 4xx7
// module chunks = 1